/*
* 修复ios页面不回弹问题
*/

let scrollY = window.scrollY
let timer = null
const isIos = /iPhone|iPad|iPod/.test(navigator.userAgent)

function checkInput (dom) {
  return dom.tagName.toLowerCase() === 'input' && (dom.type === 'text' || dom.type === 'textarea' || dom.type === 'password')
}

function focusIn (e) {
  if (checkInput(e.target)) {
    scrollY = window.scrollY
    if (timer) clearTimeout(timer)
  }
}

function focusOut (e) {
  if (checkInput(e.target)) {
    timer = setTimeout(function() {
      window.scrollTo(0, scrollY) 
    })
  }
}

function bind (el, binding) {
  if (!isIos) return
  window.addEventListener('focusin', focusIn)
  window.addEventListener('focusout', focusOut)
}

function unbind (el, binding) {
  if (!isIos) return
  window.removeEventListener('focusin', focusIn)
  window.removeEventListener('focusout', focusOut)
}

export default {
  bind: bind,
  unbind: unbind,
  update: function(el, binding) {
    if (binding.value === undefined) return
    if (binding.value) {
      bind(el, binding)
    } else {
      unbind(el, binding)
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/directives/rebound.js